import { JenjangRepositoryInterface } from '../../../data/contracts/Jenjang';
import { JenjangDataMapper } from '../../../data/mappers/Jenjang';
import { Jenjang } from '../../../entities/Jenjang';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';

export class JenjangApiRepository implements JenjangRepositoryInterface {
  private apiService: ApiService;
  private mapper: JenjangDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: JenjangDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllJenjang(): Promise<Jenjang[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.jenjang(),
      {},
      null,
      headers
    );
    return this.mapper.convertListJenjangFromApi(dataResponse);
  }
}
